import { generateContentPageProps } from 'utils/next'
import { setPageCacheControlHeaders } from 'utils/cache'
import { PressView } from 'components/PressView'
import { get as _get } from 'lodash-es'
import { PageHandler } from 'components/ContentHandlers'
import { generateWebPageProps } from 'utils/next'
import { CONTENT_TYPES, PAGE_LIMIT_DEFAULT } from 'services/contentful/constants'
import { defaultListArticles } from 'services/contentful/helpers'

// Added ContentfulLiveUpdates only for sbx environment
// Doing it like this to avoid shipping unnecessary code to production and reducing the bundle size
let useContentfulLiveUpdates = () => null

if (process.env.NEXT_PUBLIC_APP_ENV === 'sbx') {
  useContentfulLiveUpdates = require('@contentful/live-preview/react').useContentfulLiveUpdates
}

export async function getServerSideProps(context) {
  setPageCacheControlHeaders(context.res)

  const identifyUrlFilter = _get(context, 'query.slug')
  const filterTopics = ['in-the-news', 'press-release', 'executive-insights', 'data-analytics']

  let serverSideProps = null

  if (filterTopics.includes(identifyUrlFilter)) {
    serverSideProps = await generateWebPageProps(context, {
      pageRoute: '/about/press',
      forceRoute: '/about/press',
    })
    const skip = context?.query?.page ? (context?.query?.page - 1) * PAGE_LIMIT_DEFAULT : 0
    const defaultList = await defaultListArticles(CONTENT_TYPES.PRESS_STORY, skip)

    serverSideProps?.props?.content?.fields?.sections.map((section) => {
      if (section?.fields?.fieldName == 'pressStoryGrid') {
        section.fields.sectionContents.push({
          fields: {
            fieldName: 'listArticles',
            defaultList: defaultList.items,
            total: defaultList.total,
          },
        })
      }
    })
    return serverSideProps
  }

  serverSideProps = await generateContentPageProps(context)
  const articleCount = _get(serverSideProps, 'props.content.total', 0)
  if (articleCount < 1) {
    return {
      notFound: true,
    }
  }

  return serverSideProps
}

export default function PressDetails({ content, isMobile, completePageUrl }) {
  const contentCopy = JSON.parse(JSON.stringify(content))
  const updatedPost = useContentfulLiveUpdates(content.items?.[0])

  if (Array.isArray(contentCopy.items)) {
    contentCopy.items[0] = updatedPost ? updatedPost : content.items?.[0]
  }

  let aboutIndex = completePageUrl.indexOf('/about/press')
  const isAbout = aboutIndex !== -1 && completePageUrl.indexOf('/', aboutIndex + 12) == -1
  return isAbout ? (
    <PageHandler pageContent={contentCopy} isMobileUA={isMobile} />
  ) : (
    <PressView content={contentCopy} completePageUrl={completePageUrl} isMobileUA={isMobile} />
  )
}
